import { Component, Inject, ViewChild,ElementRef, Renderer2} from '@angular/core';
import { Router, NavigationStart, ActivatedRoute, Params } from '@angular/router';
import * as OktaSignIn from '@okta/okta-signin-widget';
const DEFAULT_ORIGINAL_URI = window.location.origin;
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { filter, map, Observable } from 'rxjs';
import { StoranConstant } from '../../storan-constant';
import { Title } from '@angular/platform-browser';
import { SignupuserService } from '../../services/signupuser.service'
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})

export class LoginComponent {

  public isAuthenticated$!: any;
  private _oktaStateService: any;
  signIn: any;
  requestContextURL: any;
  emailAddress: any;
  password: any;
  showPasswordfield: boolean = false;
  activationCodeFlag: boolean = false;
  activationCode: any;
  activateFlag: boolean = false;
  userDetails: any;
  errorMessage: string = '';
  errorMessageEmail: string = '';
  showErrorMessageEmail: boolean = false;
  errFlagPop: boolean = false;
  activeMsg: any;
  keepmeSignedIn: boolean = false;
  expirationDate: any;
 disbaleNextbtn:boolean = true;
 errLogin:boolean = false;
 errorLoginMsg:any='';
 @ViewChild('logActivateT') logActivateT!: ElementRef<HTMLElement>;
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth,private scroller: ViewportScroller,
    public authStateService: OktaAuthStateService, private route: ActivatedRoute, private router: Router, private title: Title, private signUpservice: SignupuserService, private authService: AuthService, private spinner: NgxSpinnerService) {
    this.title.setTitle("Log In | Storen Satisfaction Program")
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      document.getElementById("logScreen")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      document.getElementById("logActivate")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    },600);
  
  }
  ngOnInit() {
   
    if (this.signUpservice.loginvalidationmessage != '') {
      this.errLogin = true;
      this.errorLoginMsg = this.signUpservice.loginvalidationmessage;
    }
    // localStorage.removeItem("email");
    // localStorage.removeItem('keepmesigned');
    this.authService.checkAuthAndRedirectHome();
    let authConfig = JSON.parse(JSON.stringify(StoranConstant.getEnvironmentVariable()));
    this.route.queryParams.subscribe((params: Params) => {
      this.activationCode = decodeURIComponent(params['code']);
      if (this.activationCode === undefined || this.activationCode === 'undefined' || this.activationCode === '' || this.activationCode === null) {
        this.activationCodeFlag = false;
      } else { 
        this.activationCodeFlag = true;
      }
    });

  }
  activateAccount() {
    this.spinner.show();
    this.signUpservice.activeUser(this.activationCode).subscribe(res => {
      let emailID = JSON.parse(res);
      if (emailID.length > 0) {
        let storanObj = {
          "Email": emailID[0]['email'],
          "MobileToken": "",
          "WebToken": this.activationCode,
          "Website": "SSP"
        }
        this.signUpservice.storenvalidatetoken(storanObj).subscribe(response => {
          if (response['Status'] == 'Success') {
            this.spinner.hide();
            this.activateFlag = false;
            this.activeMsg = '';
            localStorage.setItem('isWelcome', 'true');
            this.router.navigate(['/sign-up/welcome']);
            // this.router.navigateByUrl('/sign-up/welcome');
            // this.activateFlag = true;
            // this.activeMsg = 'Your Storen account has been activated. You may now login with your email address and password.';
          } else if (response['Status'] == 'Email address is already activated') {
            this.spinner.hide();
            this.activateFlag = true;
            this.activeMsg = 'Your Email Address is already activated. Please Log in to your Storen Satisfaction Program account.';
          } else if (response['Status'] == 'Activation failed for the email id') {
            this.spinner.hide();
            this.activateFlag = true;
            this.activeMsg = 'Something went wrong during activation of your account. Please try again later.';
          } else {
            this.spinner.hide();
            this.activateFlag = false;
            this.activeMsg = '';
            this.router.navigate(['/error'])
          }
        });
      } else {

        this.spinner.hide();
        this.errFlagPop = true;
      }
    });

  }
  validateUser(event:any){
    this.disbaleNextbtn =  false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(this.emailAddress);
    if (valid === true) {
      let checkSyngentaUser = this.emailAddress.includes('syngenta');
      if(checkSyngentaUser){
        this.showPasswordfield = false;
        this.showErrorMessageEmail = false;
        this.errorMessageEmail ="";
        this.errorMessage ="";
      } else{
        this.showPasswordfield = true;
        this.showErrorMessageEmail = false;
        this.errorMessageEmail ="";
        this.errorMessage ="";
      }
    } else{
      this.errorMessage ="";
      this.showErrorMessageEmail = true;
      this.errorMessageEmail = "Please enter a valid email.";
    }
  
   
  }
  next() {
    this.spinner.show();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(this.emailAddress);
    if (this.emailAddress) {
      if (valid === true) {
        let checkSyngentaUser = this.emailAddress.includes('syngenta');
   
        //If Syngenta User redirect to Okta login and hide password field
        if (checkSyngentaUser === true) {
          this.spinner.hide();
          this.showPasswordfield = false;
         // localStorage.setItem("email",this.emailAddress);
         this.spinner.show();
          localStorage.setItem("email",this.emailAddress);
          localStorage.setItem('keepmesigned', JSON.stringify(this.keepmeSignedIn));
          // localStorage.setItem("keepmesigned",this.keepmeSignedIn);
          this.oktaAuth.signInWithRedirect({ 
                  loginHint: this.emailAddress,
                });
        
        } else {
          this.spinner.hide();
          this.showPasswordfield = true;
          this.showErrorMessageEmail = false;
          localStorage.removeItem("email");
          localStorage.removeItem('keepmesigned');
        }

      } else {
        this.spinner.hide();
        this.errorMessage = '';
        this.showErrorMessageEmail = true;
        this.errorMessageEmail = "Please enter a valid email.";
      }
    } else {
      this.spinner.hide();
      this.errorMessage = '';
      this.showErrorMessageEmail = true;
      this.errorMessageEmail = "Enter your email address to proceed"
    }

  }
  login() {
    let loginAttempts = 0;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(this.emailAddress);
    if (this.emailAddress && this.password && valid) {
      this.spinner.show();

      this.oktaAuth.signInWithCredentials({
        username: this.emailAddress,
        password: this.password
      }).then(transaction => {
        if (transaction.status === 'SUCCESS') {
          this.signUpservice.UpdateGrowersLastLogin(this.emailAddress).subscribe(res => {
            if (res.length > 2 && res !== "[]" && res !== '') {
              localStorage.setItem("email",this.emailAddress);
                localStorage.setItem("userDetails",res);
              this.userDetails = JSON.parse(res);
            //  localStorage.setItem('userDetails', JSON.stringify(res));
              this.signUpservice.setUserDetails(this.userDetails);
              if (this.userDetails[0].ACTIVE_IND > 0) {
               
                // Seting the cookie with expiry date of 10 days
                // const expiryDate = new Date();
                // expiryDate.setDate(expiryDate.getDate() + 10);
                let currentdate = new Date();
                if (this.keepmeSignedIn === true) {
                  // Adding for 30 days
                  // this.expirationDate = new Date(currentdate);
                  // this.expirationDate.setDate(currentdate.getDate() + 30); //Adding 30 days

                  const currentDate = new Date();
                  currentDate.setDate(currentDate.getDate() + 30);
                  let timeAfterHours = currentDate.toLocaleString('en-US',{
                    timeZone:'America/New_York',
                    hour12:false,
                    weekday:'long',
                    year:'numeric',
                    month:'long',
                    day:'numeric',
                    hour:'numeric',
                    minute:'numeric',
                    second:'numeric'
                  });
                 
                  this.expirationDate = timeAfterHours;
                } else {
                   // this.expirationDate = new Date(currentdate);
                  // this.expirationDate.setHours(currentdate.getHours() + 24); //Adding 24 hours
                  const currentDate = new Date();
                  currentDate.setHours(currentDate.getHours() + 24);

                  let timeAfterHours = currentDate.toLocaleString('en-US',{
                    timeZone:'America/New_York',
                    hour12:false,
                    weekday:'long',
                    year:'numeric',
                    month:'long',
                    day:'numeric',
                    hour:'numeric',
                    minute:'numeric',
                    second:'numeric'
                  });
                
                this.expirationDate = timeAfterHours;
                }
                
                //document.cookie = `loggedIn=true; expires=${expiryDate.toUTCString()}; path=/`;
                //document.cookie = `userName=${this.userDetails[0].USER_FIRST_NAME}; expires=${expiryDate.toUTCString()}; path=/`;
                //document.cookie = `userRole=${this.userDetails[0].JOB_TITLE}; expires=${expiryDate.toUTCString()}; path=/`;
       
                document.cookie = `userDetails=${JSON.stringify({ loggedIn: true, userName: this.userDetails[0].USER_FIRST_NAME + " " + this.userDetails[0].USER_LAST_NAME, userRole: this.userDetails[0].JOB_TITLE ,email: this.emailAddress})}; expires=${this.expirationDate}; path=/`;
                let usdt = `userDetails=${JSON.stringify({ loggedIn: true, userName: this.userDetails[0].USER_FIRST_NAME + " " + this.userDetails[0].USER_LAST_NAME, userRole: this.userDetails[0].JOB_TITLE,email: this.emailAddress })}; expires=${this.expirationDate}; path=/`;
                this.signUpservice.updateDynamicText(usdt);
                localStorage.setItem("email",this.emailAddress);
                localStorage.setItem('userDetails', usdt);
                this.authService.login();
                this.spinner.hide();
                this.router.navigate(['/program'])

              } else {
                this.errorMessage = "We're unable to find an active account with this email address "+"\""+ this.emailAddress+  "\""+".   Please check if you've registered and activated your Storen Satisfaction Program account.";
                this.spinner.hide();
                this.showErrorMessageEmail = false;
                this.errorMessageEmail = "";
              }
            } else {
               this.errorMessage = "We're unable to find an active account with this email address "+"\""+ this.emailAddress+  "\""+".   Please check if you've registered and activated your Storen Satisfaction Program account."; this.errorMessage = "We're unable to find an active account with this email address "+"\""+ this.emailAddress+  "\""+".   Please check if you've registered and activated your Storen Satisfaction Program account.";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            }
          });
        } else {
         
          this.signUpservice.UpdateGrowersLoginAttempt(this.emailAddress).subscribe(res => {
            
           this.userDetails = JSON.parse(res);
           if (this.userDetails[0].LoginAttempt != null) {
             loginAttempts = this.userDetails[0].LoginAttempt;
            if (loginAttempts < 3) {
            
              this.errorMessage = "You have entered an invalid password.";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            } else if (loginAttempts < 10) {
             
              loginAttempts = 10 - loginAttempts;
              this.errorMessage = "You have entered an invalid password Your account will be locked after " + loginAttempts + " more failed attempts. If you have forgotten your password, please click the 'Forgot Password?' link below.";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            } else {
              
              this.errorMessage = "Your account has now been locked. Please contact us at campaigns.support@syngenta.com for assistance";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            }
          } else{
           this.errorMessage = "We're unable to find an active account with this email address "+"\""+ this.emailAddress+  "\""+".   Please check if you've registered and activated your Storen Satisfaction Program account.";
          this.spinner.hide(); 
          }
        

        
          });
       }
      }).catch(err => {
        console.error('Login failed', err);
      
        // this.errorMessage = "The email address or password you entered is incorrect. Please try again.";
        this.showErrorMessageEmail = false;
        this.errorMessageEmail = "";
        this.signUpservice.UpdateGrowersLoginAttempt(this.emailAddress).subscribe(res => {
 
         if (res) {
           this.userDetails = JSON.parse(res);
           if (this.userDetails[0].LoginAttempt != null) {
             loginAttempts = this.userDetails[0].LoginAttempt;
             if (loginAttempts < 3) {
             
              this.errorMessage = "You have entered an invalid password.";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            } else if (loginAttempts < 10) {
             
              loginAttempts = 10 - loginAttempts;
              this.errorMessage = "You have entered an invalid password Your account will be locked after " + loginAttempts + " more failed attempts. If you have forgotten your password, please click the 'Forgot Password?' link below.";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            } else {
             
              this.errorMessage = "Your account has now been locked. Please contact us at campaigns.support@syngenta.com for assistance";
              this.spinner.hide();
              this.showErrorMessageEmail = false;
              this.errorMessageEmail = "";
            }
           }
           else {
            this.errorMessage = "We're unable to find an active account with this email address "+"\""+ this.emailAddress+  "\""+".   Please check if you've registered and activated your Storen Satisfaction Program account.";
             this.spinner.hide();
           }
         }
         else {
           this.errorMessage = "Something went wrong please try again later";
           this.spinner.hide();
         }
        });
      });

    } else {

      if ((this.emailAddress !== undefined && this.password === undefined && valid) ||
        (this.emailAddress !== '' && this.password === '' && valid)) {
        this.spinner.hide();
        this.errorMessage = "Password is required.";
      } else if ((this.emailAddress === undefined && this.password !== undefined && !valid) ||
        (this.emailAddress === '' && this.password !== '' && !valid)) {
        this.spinner.hide();
        this.showErrorMessageEmail = true;
        this.errorMessageEmail = "Email is required.";
        this.errorMessage = '';
      } else if ((this.emailAddress === undefined && this.password === undefined && !valid) ||
        (this.emailAddress === '' && this.password === '' && !valid)) {
        this.spinner.hide();
        this.showErrorMessageEmail = false;
        this.errorMessageEmail = "";
        this.errorMessage = 'Please enter email address and password.';
      } else {
        this.spinner.hide();
        this.showErrorMessageEmail = true;
        this.errorMessageEmail = "Please enter valid email address.";
        this.errorMessage = '';
      }

    }
  }
  frgtPasswd() {
    this.router.navigateByUrl('/log-in/forgot-password');
  }
  loginbtn() {
    this.activateFlag = false;
    localStorage.setItem('isWelcome', 'false');
    this.router.navigateByUrl('/log-in');
    // this.router.navigateByUrl('/sign-up/welcome');
  }


}
